export default {
  SET_SALES: (state, payload) => {
    state.sales = payload;
  },
  GET_SALES_ID:(state,payload)=>{    
    state.salesById = payload;
  },
}
